import { BlogPostContent } from '@/types/blog';
import { intro } from './sections/intro';
import { zieldirektive } from './sections/zieldirektive';
import { kernregeln } from './sections/kernregeln';
import { prozessor } from './sections/prozessor';
import { fazit } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    intro,
    zieldirektive,
    kernregeln,
    prozessor,
    fazit
  ]
};
